module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Light.2c7bbe4c.eot";